import React from "react";

export const BasketContext = React.createContext();
export const BasketDispatchContext = React.createContext();



function BasketProvider({children}) {
    const [state,setstate] = React.useState([])
    return(
        <BasketContext.Provider value={state}>
            <BasketDispatchContext.Provider value={setstate} >
                {children}
            </BasketDispatchContext.Provider>
        </BasketContext.Provider>
    )
}

export {BasketProvider};
